<template>
    <l-marker :visible="visible" :lat-lng="coordinates" :draggable="localDraggable" :ref="referId"
        @dragend="updateByDrag" @click="$emit('click', (item || {}).reference)">
        <l-icon :icon-anchor="[20, 40]" :icon-size="[40, 40]" className="custom-icon">
            <svg :class="classHandler" id="Goccia" xmlns="http://www.w3.org/2000/svg" viewBox="-19 -3 159.5 190.4">
                <path id="Traccia_goccia" data-name="Traccia goccia"
                    d="M164,84.8c0,33-59.7,109.2-59.7,109.2S44.5,117.8,44.5,84.8a59.8,59.8,0,0,1,119.5,0Z"
                    transform="translate(-44.5 -12.6)" fill="#fff" />
                <path id="Base_goccia" data-name="Base goccia"
                    d="M157.4,87.6c0,29.3-53.1,97-53.1,97s-53.1-67.7-53.1-97a53.1,53.1,0,0,1,106.2,0Z"
                    transform="translate(-44.5 -12.6)" fill="#c9f0cc" />
                <path id="Mezza_goccia_riflesso" data-name="Mezza goccia riflesso"
                    d="M157.4,87.6a53.1,53.1,0,0,0-53.1-53.1V184.6S157.4,116.9,157.4,87.6Z"
                    transform="translate(-44.5 -12.6)" fill="#a4d6a8" />
                <g class="rotate" fill="div-rotate">
                    <path id="Freccia_direzionale" data-name="Freccia direzionale"
                        d="M150.1,86.4a45.9,45.9,0,0,0-30.2-43.1L104.3,12.6,88.7,43.3a45.8,45.8,0,1,0,61.4,43.1Z"
                        transform="translate(-44.5 -12.6)" :class="{ 'custom-color': customizer.custom_color }"
                        :fill="customizer.custom_color ? customizer.custom_color : '#657565'" />
                </g>
                <text :x="markerSizeHandler.x ? markerSizeHandler.x : 28"
                    :y="markerSizeHandler.y ? markerSizeHandler.y : 92" style="
                        font-family: 'Font Awesome Kit', 'FontAwesome', 'Font Awesome 6 Pro';
                        font-size: 52px;
                    " fill="#fff" v-if="iconUnicode" v-html="iconUnicode ? `&${iconUnicode};` : '&#xe00d;'"></text>
                <text x="56" y="92" style="font-size: 52px; font-weight: 700" fill="#fff" text-anchor="middle" v-else>
                    {{ markerInnerLabel + 1 }}
                </text>
            </svg>
            <div class="plate" :class="classHandler" v-if="markerTitle != __('planner.vehicle_actual_position')"
                v-b-tooltip.hover :title="markerTitle">
                <span class="borsa-icon" v-show="customizer.color_class == 'borsa.delivery' ||
                    customizer.color_class == 'borsa'
                    ">
                    {{ customizer.color_class == 'borsa' ? '&#xf0aa;' : '&#xf0ab;' }}
                </span>
                <span>{{ computedMarkerLabel }}</span>
            </div>
        </l-icon>

        <!-- Tooltip al passaggio del mouse -->
        <l-tooltip v-if="item?.data" :options="{ direction: 'top' }">
            <div class="d-flex align-items-center gap-3">
                <div class="d-flex flex-column gap-1">
                    <span class="fw-bold">
                        {{ item.data.transportFreight.spots[0].locality }}
                    </span>
                    <span>
                        {{ getDaysDifference(item.data.transportFreight.spots[0]) }}
                    </span>
                </div>
                <i class="fa fa-arrow-right"></i>
                <div class="d-flex flex-column align-items-end gap-1">
                    <span class="fw-bold">
                        {{ item.data.transportFreight.spots[1].locality }}
                    </span>
                    <span>
                        {{ getDaysDifference(item.data.transportFreight.spots[1]) }}
                    </span>
                </div>
                <!-- <div v-if="item.data.payment_period_days" class="fw-bolder" style="color: var(--success)">
                    {{ item.data.price_currency }} -
                </div> -->
            </div>
        </l-tooltip>

        <!-- Popup al click (opzionale - commentato per default) -->
        <l-popup v-if="item?.data" style="min-width: 300px">
            <div class="mt-4">
                <div class="popup-grid">
                    <!-- Riga 1: col-span 2, con gap di 10px sotto -->
                    <div class="popup-grid-header d-flex align-items-center justify-content-between gap-2">
                        <div class="d-flex align-items-baseline gap-1">
                            <div class="bg-success rounded-circle" style="width: 12px; height: 12px"></div>
                            <span class="fw-bold text-nowrap">
                                {{ item.data.transportFreight.spots[0].locality }}
                            </span>
                        </div>
                        <div class="w-100" style="border-bottom: 2px dotted #d1d5db"></div>
                        <i class="fa fa-arrow-right text-muted"></i>
                        <div class="w-100" style="border-bottom: 2px dotted #d1d5db"></div>
                        <div class="d-flex align-items-baseline gap-1">
                            <div class="bg-danger rounded-circle" style="width: 12px; height: 12px"></div>
                            <span class="fw-bold text-nowrap">
                                {{ item.data.transportFreight.spots[1].locality }}
                            </span>
                        </div>
                    </div>

                    <!-- Righe 2-8: due colonne separate -->
                    <div class="text-muted">{{ __('freight_exchange.popup_key.company') }}</div>
                    <div>{{ item.data.company_name }}</div>
                    <div class="text-muted">{{ __('freight_exchange.popup_key.vehicle_size') }}</div>
                    <div>{{ item.data.transportFreight.vehicle_size }}</div>
                    <div class="text-muted">{{ __('freight_exchange.popup_key.required_truck_bodies') }}</div>
                    <div>{{ item.data.transportFreight.required_truck_bodies.join(', ') }}</div>
                    <!-- <div class="text-muted">{{ __('freight_exchange.popup_key.distance') }}</div>
                    <div></div> -->
                    <div class="text-muted">{{ __('freight_exchange.popup_key.pickup') }}</div>
                    <div class="text-nowrap">{{ item.data.transportFreight.spots[0].local_begin }} {{
                        item.data.transportFreight.spots[0].local_hour_begin }} ~ {{
                            item.data.transportFreight.spots[0].local_end }} {{
                            item.data.transportFreight.spots[0].local_hour_end }}</div>
                    <div class="text-muted">{{ __('freight_exchange.popup_key.delivery') }}</div>
                    <div class="text-nowrap">{{ item.data.transportFreight.spots[1].local_begin }} {{
                        item.data.transportFreight.spots[1].local_hour_begin }} ~ {{
                            item.data.transportFreight.spots[1].local_end }} {{
                            item.data.transportFreight.spots[1].local_hour_end }}</div>
                    <div class="text-muted">{{ __('freight_exchange.popup_key.price') }}</div>
                    <div>-</div>
                </div>
                <golia-button variant="btn-fill golia" class="w-100" style="font-size: 14px"
                    :label="__('freight_exchange.popup_key.open_in_golia_exchange')" @click="openOfferLink" />
            </div>
        </l-popup>
    </l-marker>
</template>

<script>
import { LMarker, LIcon, LPopup, LTooltip } from 'vue2-leaflet'
import { mapGetters } from 'vuex'

export default {
    name: 'CustomMarker',
    props: {
        referId: String,
        item: Object,
        visible: { Boolean, default: true },
        coordinates: Array,
        markerTitle: [String, Number],
        markerInnerLabel: [String, Number],
        iconUnicode: String,
        customizer: Object,
        draggable: { Boolean, default: false },
        highlighted: { Boolean, default: false }
    },
    components: {
        LMarker,
        LIcon,
        LPopup,
        LTooltip
    },
    data() {
        return {
            bounce: false,
            localDraggable: false
        }
    },
    methods: {
        updateByDrag: function (e) {
            let position = e.target.getLatLng()

            this.$emit('updateByDrag', [position.lat, position.lng])
        },
        openOfferLink: function () {
            window.open(
                `https://exchange.goliaweb.it/search/${this.getFELastSearch.id}/details/${this.item.data.id}`,
                '_blank'
            )
        },
        getDaysDifference: function (spot) {
            const { local_begin, local_end } = spot
            if (local_begin && local_end) {
                const [day, month, year] = local_begin.split('/').map(Number);
                const d1 = new Date(year, month - 1, day);
                const [day2, month2, year2] = local_end.split('/').map(Number);
                const d2 = new Date(year2, month2 - 1, day2);
                const diff = (d2 - d1) / (1000 * 60 * 60 * 24)

                return `${local_begin}${diff > 0 ? ` (+${diff})` : ''}`
            }
            return ''
        }
    },
    watch: {
        visible: function (val) {
            if (this.draggable === true) {
                this.localDraggable = val
            }
        }
    },
    mounted: function () {
        this.$nextTick(function () {
            if (this.draggable === true) {
                this.localDraggable = this.draggable
            }
        })
    },
    computed: {
        ...mapGetters({
            getFELastSearch: 'getFELastSearch'
        }),
        classHandler: function () {
            let className = ''

            if ((this.item || {}).on_focus || this.highlighted) {
                className += 'bounce'
            }

            if (this.customizer.tiny) {
                className += ' tiny'
            }

            if (this.customizer.color_class) {
                className += ' ' + this.customizer.color_class
            }

            return className
        },
        markerSizeHandler: function () {
            var size = { x: 28, y: 92 }

            if (this.customizer.color_class == 'fuel') {
                size.x = 28
                size.y = 92
            } else if (this.customizer.color_class == 'parking') {
                size.x = 32
                size.y = 92
            } else if (this.customizer.color_class == 'poi') {
                size.x = 38
                size.y = 92
            } else if (
                this.customizer.color_class == 'borsa' ||
                this.customizer.color_class == 'borsa-timocom' ||
                this.customizer.color_class == 'borsa.delivery'
            ) {
                size.x = 26
                size.y = 92
            } else if (
                this.customizer.color_class == 'start' ||
                this.customizer.color_class == 'finish'
            ) {
                size.x = 36
                size.y = 92
            }

            if (this.iconUnicode == '#xf041' || this.iconUnicode == '#xf2f2') {
                size.x = 38
                size.y = 92
            }

            return this.customizer.size_x ? { x: this.customizer.size_x, y: 92 } : size
        },
        computedMarkerLabel: function () {
            if (this.markerTitle)
                return this.markerTitle.length > 20
                    ? this.$options.filters.truncate(this.markerTitle, 20, '...')
                    : this.markerTitle
            else return ''
        }
    }
}
</script>

<style scoped lang="scss">
@use './CustomMarker.scss';
</style>
